export default "__VITE_ASSET__ClaSFHOz__"